<template>
  <b-list-group-item
    :to="{ path: `Artikel/${article.id}`}"
    class="flex-column align-items-start"
  >
    <div class="d-flex w-100 justify-content-between">
      <h5 class="mb-1 text-primary">
        {{ article.title }}
      </h5>
      <small class="text-muted createdDate">{{ date }}</small>
    </div>

    <p
      class="mb-1"
      v-html="article.preview"
    />
  </b-list-group-item>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ArticleListEntry',
  data () {
    return {
      articleId: parseInt(this.$vnode.key)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredArticleById'
    ]),
    article () {
      return this.getStoredArticleById(this.articleId)
    },
    date () {
      const d = new Date(this.article.public_at)
      return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear()
    }
  }
}

</script>

<style scoped>
  .createdDate {
    flex: inherit !important;
  }
</style>
